export const Logo = ({ size = 28, className = "" }) => (
  <span
    className={`inline-flex items-center justify-center rounded-[24%] bg-black border border-white/15 shrink-0 ${className}`}
    style={{ width: size * 1.25, height: size * 1.25 }}
    aria-label="CastleCorp"
  >
    <img src="/brand/logo-mark.png" alt="CastleCorp mark" className="block object-contain" style={{ width: "72%", height: "72%", transform: "translateY(-4%)" }} />
  </span>
);

export const Wordmark = ({ className = "", variant = "auto" }) => (
  <img
    src="/brand/wordmark.png"
    alt="CASTLECORP"
    className={`h-[13px] w-auto brand-wordmark ${variant === "silver" ? "brand-wordmark-dark" : ""} ${className}`}
  />
);
